import { ComponentProps, useMemo } from 'react'
import { TrackingStatus, TrackingViewProps } from './Tracking.types'
import Text from 'openspace/components/Text'
import { LPTypo } from 'containers/OneUIProvider/OneUIProvider.data'
import { tO } from 'translate/i18n'
import IconRarum from 'components/IconRarum'
import Styles from './Tracking.module.scss'
import { Delivery } from '@onepercentio/rarum-types/deliveries'
import { logDevError } from 'context/ErrorReporting'

export function TrackingStatusLabel({
  status,
  mode = 'buyer',
}: { status: TrackingStatus } & Partial<Pick<TrackingViewProps, 'mode'>>) {
  return (
    <>
      <Text type={LPTypo.P2} className={Styles.statusRowLabel}>
        <IconForStatus mode='raw' status={status} />
        &nbsp;{tO(`tracking.status.${mode}.label.${status}`)}
      </Text>
    </>
  )
}

export function IconForStatus({
  status,
  mode,
}: {
  status: TrackingStatus
  mode: 'raw' | 'current' | 'past' | 'error' | 'warning'
}) {
  const iconByStatus = useMemo<ComponentProps<typeof IconRarum>['icon']>(() => {
    switch (status) {
      case 'PAYED':
      case 'PROCESSED':
      case 'IN_TRANSIT':
      case 'OUT_FOR_DELIVERY':
      case 'DELIVERED':
      case 'FAILED_AWAIT':
      case 'FAILED_COLLECT':
      case 'FAILED_RETURN':
      case 'FAILED_CONTACT':
      case 'DELIVERY_FAILED':
      case 'AWAITING_POST':
        return 'box'
    }
  }, [status])

  return (
    <div className={`${Styles[mode]} ${Styles.iconContainer}`}>
      <IconRarum icon={iconByStatus} size={16} />
    </div>
  )
}

export const trackingUrlByProvider = (
  provider: NonNullable<Delivery['logistics']>['provider'],
  trackingCode: string
) => {
  switch (provider) {
    case 'correios':
      return `https://rastreamento.correios.com.br/app/index.php?objetos=${trackingCode}`
    case undefined:
      return undefined
    default:
      logDevError(
        `Tracking provider link not mapped for provider ${provider}.`,
        module
      )
      return undefined
  }
}
